import { CarrierSubmissionClient } from 'clients';
import { QueryKeys } from 'enums';
import { CarrierSubmissionSearchFilter, CarrierSubmissionSearchItem } from 'types';
import { UseQueryBaseSearchOptions } from './query/types';
import { useQuerySearch } from './query/useQuery';

export function useSearchCarrierSubmissions(
  props: UseQueryBaseSearchOptions<CarrierSubmissionSearchItem, CarrierSubmissionSearchFilter> = {},
) {
  const { filter, queryOptions, enabled } = props;
  return useQuerySearch<
    CarrierSubmissionSearchItem,
    CarrierSubmissionSearchItem,
    CarrierSubmissionClient,
    CarrierSubmissionSearchFilter
  >({
    queryKey: QueryKeys.CarrierSubmissions,
    clientClass: CarrierSubmissionClient,
    enabled,
    filter,
    queryOptions,
  });
}
